// Central contact channels — this site has no forms/app; reach out directly.
export const CONTACT_EMAIL = "contato@sec4us.com.br";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const CONTACT_WHATSAPP =
  "https://wa.me/5541988866006?text=Tenho%20interesse%20em%20conhecer%20melhor%20o%20SecFace.";
